import CardFragmentConfig from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/CardFragmentConfig";
import { reportMessageToSentry } from "@coworker/app/src/hooks/useConfigureSentry";
import TitleCardFragment from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/TitleCardFragment/TitleCardFragment";
import TextCardFragment from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/TextCardFragment/TextCardFragment";
import InvalidCardFragment from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/InvalidCardFragment/InvalidCardFragment";
import { Task } from "@coworker/apprestructured/src/task-management/types/Task";
import { Loading } from "@coworker/apprestructured/src/task-management/loading";

export type CardFragmentCommonProps = {
  task: Task | Loading;
};

type CardFragmentProps = {
  config: CardFragmentConfig;
  commonProps: CardFragmentCommonProps;
};

function CardFragment({ config, commonProps }: CardFragmentProps) {
  const { id, props: configProps } = config;
  switch (id) {
    case "title-card-fragment": {
      return <TitleCardFragment commonProps={commonProps} />;
    }
    case "text-card-fragment": {
      return (
        <TextCardFragment configProps={configProps} commonProps={commonProps} />
      );
    }
    default: {
      console.error(`'${id}' does not map to any card fragment component`);
      reportMessageToSentry(
        `Card fragment config id does not map to any card fragment component`,
        {
          id,
        },
        "error"
      );
      return <InvalidCardFragment />;
    }
  }
}

export default CardFragment;
